import React from 'react';
import './ContactPage.css';
import { openWhatsAppWithMessage, WHATSAPP_PHONE } from '../utils/contact';

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get('name') || '';
    const email = formData.get('email') || '';
    const phone = formData.get('phone') || '';
    const topic = formData.get('topic') || '';
    const messageBody = formData.get('message') || '';

    const message = [
      'New CONTACT MESSAGE from mtpro.com',
      '',
      `Name: ${name}`,
      `Email: ${email}`,
      `Phone: ${phone}`,
      topic ? `Inquiry about: ${topic}` : '',
      '',
      'Message:',
      messageBody,
    ].join('\n');

    openWhatsAppWithMessage(message);
  };
  return (
    <section className="contact-page">
      <div className="contact-container">
        {/* Left Side - Contact Details */}
        <div className="contact-details">
          <div className="contact-header">
            <span className="contact-tag">GET IN TOUCH</span>
            <h2 className="contact-main-title">Let's Start a Conversation</h2>
            <p className="contact-intro">
              Whether you're exploring our services or envisioning something custom, 
              we're here to bring your vision to life.
            </p>
          </div>

          <div className="contact-info-list">
            <div className="contact-info-item">
              <div className="contact-icon-box">
                <span className="contact-icon">📞</span>
              </div>
              <div className="contact-info-content">
                <h4 className="contact-info-label">Phone</h4>
                <p className="contact-info-value">+{WHATSAPP_PHONE}</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon-box">
                <span className="contact-icon">✉️</span>
              </div>
              <div className="contact-info-content">
                <h4 className="contact-info-label">Email</h4>
                <p className="contact-info-value">info@mtproeg.com</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon-box">
                <span className="contact-icon">📍</span>
              </div>
              <div className="contact-info-content">
                <h4 className="contact-info-label">Address</h4>
                <p className="contact-info-value">
                  Sheikh Zayed City<br />
                  Cairo, Egypt 12345
                </p>
              </div>
            </div>
          </div>

          <div className="contact-social">
            <h4 className="social-title">Follow Us</h4>
            <div className="social-icons">
              <span className="social-item">Facebook</span>
              <span className="social-item">Instagram</span>
              <span className="social-item">LinkedIn</span>
              <span className="social-item">YouTube</span>
            </div>
          </div>
        </div>

        {/* Right Side - Contact Form */}
        <div className="contact-form-section">
          <div className="form-header">
            <h3 className="form-title">Send Us a Message</h3>
            <p className="form-subtitle">
              Fill out the form below and we'll get back to you within 24 hours.
            </p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                placeholder="Your Name*" 
                className="form-input"
                name="name"
                required 
              />
            </div>

            <div className="form-group">
              <input 
                type="email" 
                placeholder="Email Address*" 
                className="form-input"
                name="email"
                required 
              />
            </div>

            <div className="form-group">
              <input 
                type="tel" 
                placeholder="Phone Number*" 
                className="form-input"
                name="phone"
                required 
              />
            </div>

            <div className="form-group">
              <select className="form-input" name="topic" defaultValue="" required>
                <option value="" disabled>What are you inquiring about?*</option>
                <option value="pm">Project Management</option>
                <option value="telecom">Telecommunications</option>
                <option value="it">Information Technology</option>
                <option value="oilgas">Oil & Gas Services</option>
                <option value="risk">Risk Management</option>
                <option value="pmo">PMO Set-up</option>
              </select>
            </div>

            <div className="form-group">
              <textarea 
                placeholder="Your Message*" 
                className="form-textarea"
                name="message"
                rows="6"
                required
              ></textarea>
            </div>

            <div className="form-footer">
              <p className="form-note">
                <span>Required fields are marked *</span>
              </p>
              
              <button type="submit" className="form-submit-btn">
                Send Message
                <span className="btn-arrow">↗</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
